module.exports = __webpack_public_path__ + "static/media/roomba.39edce6e.jpg";